var _defs, _g, _line, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogoDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 183 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: #124c72;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5, .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-6 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: .39px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 29.04,
    y: 1.68,
    width: 12.18,
    height: 12.18,
    transform: "translate(20.04 40.44) rotate(-77.68)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1867.16,
    y1: 1399.81,
    x2: -1866.02,
    y2: 1399.81,
    gradientTransform: "translate(-19917.75 -14955.5) rotate(-180) scale(10.69 -10.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88c665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#83c363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#76bc5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#60b058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#429f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1b8a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007b38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 15.41,
    y: 27.32,
    width: 12.18,
    height: 12.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1948.86,
    y1: 1205.05,
    x2: -1947.72,
    y2: 1205.05,
    gradientTransform: "translate(-20796.97 -12860.51) rotate(-179.97) scale(10.69 -10.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6921e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f58b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f37722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f05a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ee4036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee4036"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0.87,
    y: 27.33,
    width: 12.18,
    height: 12.18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1833.51,
    y1: 1413.11,
    x2: -1832.37,
    y2: 1413.11,
    gradientTransform: "translate(-15111.46 19619.23) rotate(90.03) scale(10.69 -10.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#019bdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#078ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1078c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1c5aaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2c3392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e3191"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 27.61,
    y: 15.15,
    width: 12.18,
    height: 12.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1833.65,
    y1: 1413.41,
    x2: -1832.51,
    y2: 1413.41,
    gradientTransform: "translate(-15088.65 19609.46) rotate(90.03) scale(10.69 -10.69)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 13.14,
    y: 15.15,
    width: 12.19,
    height: 12.18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1833.66,
    y1: 1413.26,
    x2: -1832.52,
    y2: 1413.26,
    gradientTransform: "translate(-15099.58 19606.94) rotate(90.03) scale(10.69 -10.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88c665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#83c363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#76ba5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#60ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#42984a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1b7f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006e31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 27.6,
    y: 27.33,
    width: 12.18,
    height: 12.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1948.98,
    y1: 1205.06,
    x2: -1947.84,
    y2: 1205.06,
    gradientTransform: "translate(-20788.07 -12861.76) rotate(-179.97) scale(10.69 -10.69)",
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.94,13.16h-4.66l-2.79-5.16h-.03v5.16h-3.75V1.35h3.75v4.88h.03l2.69-4.88h4.58l-3.9,5.56,4.08,6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.46,4.4v1.34h4.63v2.97h-4.63v1.39h5.06v3.05h-8.81V1.35h8.72v3.05h-4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.68,13.16h-3.75v-4.18l-4.06-7.63h4.1l.83,1.99c.38.91.75,1.92,1,2.89h.03c.25-.96.61-1.97,1-2.89l.83-1.99h4.1l-4.06,7.63v4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.65,1.35c2.94,0,4.3,1.23,4.3,3.05,0,1.38-.58,2.17-1.91,2.6v.03c1.41.33,2.22,1.33,2.22,2.75,0,2.06-1.68,3.37-4.53,3.37h-5.46V1.35h5.37ZM93.86,5.94h1.04c.96,0,1.39-.32,1.39-.96s-.41-.96-1.31-.96h-1.13v1.92ZM93.86,10.47h1.09c1.01,0,1.41-.28,1.41-1s-.43-1.03-1.46-1.03h-1.04v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.1,7.25c0,3.75-2.34,6.17-5.97,6.17s-5.97-2.42-5.97-6.17,2.34-6.17,5.97-6.17,5.97,2.42,5.97,6.17ZM105.12,7.25c0,1.97.68,3.02,2.01,3.02s2.01-1.04,2.01-3.02-.68-3.02-2.01-3.02-2.01,1.04-2.01,3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.35,11.42l-.46,1.74h-3.96l3.9-11.81h4.74l3.9,11.81h-3.96l-.46-1.74h-3.68ZM120.07,7.72c-.31-1.18-.61-2.47-.86-3.67h-.03c-.25,1.19-.55,2.49-.86,3.67l-.22.83h2.19l-.22-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.81,1.35c3.1,0,4.41,1.24,4.41,3.42,0,1.46-.83,2.44-2.22,2.89v.03c.88.32,1.33.96,1.91,2.54l1.06,2.94h-3.95l-.8-2.4c-.38-1.09-.81-1.49-1.81-1.49h-.56v3.9h-3.75V1.35h5.71ZM129.86,6.62h1.26c1.06,0,1.49-.5,1.49-1.31,0-.86-.56-1.23-1.56-1.23h-1.19v2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.83,1.35c4.08,0,6.37,2.12,6.37,5.9s-2.29,5.9-6.37,5.9h-4.71V1.35h4.71ZM141.87,10.02h.83c1.62,0,2.57-1.03,2.57-2.77s-.95-2.77-2.57-2.77h-.83v5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.71,13.16V1.35h3.75v11.81h-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.1,13.16l-1.61-4.4c-.53-1.44-1.03-2.95-1.46-4.43h-.03c.1,1.56.13,3.12.13,4.68v4.15h-3.58V1.35h5.49l1.61,4.4c.53,1.44,1.03,2.95,1.46,4.43h.03c-.1-1.56-.13-3.12-.13-4.68V1.35h3.58v11.81h-5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.46,5.28h-3.98c-.1-.78-.6-1.28-1.43-1.28-1.23,0-2.01,1.26-2.01,3.3s.78,3.37,2.06,3.37c1.06,0,1.76-.75,1.82-1.77h-2.01v-2.65h5.51v6.92h-3.23v-1.04h-.03c-.71.88-1.72,1.29-2.99,1.29-3.15,0-5.08-2.32-5.08-6.1s2.25-6.22,5.97-6.22c3.1,0,5.26,1.68,5.39,4.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 56.6,
    y: 20.33,
    width: 124.8,
    height: 18.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.96,29.73c0,3.08-1.7,5.02-4.38,5.02s-4.38-1.94-4.38-5.02,1.7-5.02,4.38-5.02,4.38,1.94,4.38,5.02ZM81.5,29.73c0,2.37,1.18,3.88,3.08,3.88s3.08-1.51,3.08-3.88-1.19-3.88-3.08-3.88-3.08,1.51-3.08,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.67,34.56l-2.29-4.16c-.8-1.44-1.59-2.89-2.33-4.33h-.03c.03,1.55.04,3.08.04,4.63v3.87h-1.22v-9.66h1.83l2.31,4.16c.79,1.44,1.57,2.89,2.33,4.33h.03c-.03-1.55-.04-3.08-.04-4.63v-3.87h1.22v9.66h-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.26,33.45v1.11h-6.19v-9.66h1.25v8.55h4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.69,34.56v-9.66h1.25v9.66h-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.35,34.56l-2.29-4.16c-.8-1.44-1.59-2.89-2.33-4.33h-.03c.03,1.55.04,3.08.04,4.63v3.87h-1.22v-9.66h1.83l2.31,4.16c.79,1.44,1.57,2.89,2.33,4.33h.03c-.03-1.55-.04-3.08-.04-4.63v-3.87h1.22v9.66h-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.01,26.01v3.05h4.69v1.1h-4.69v3.28h5.13v1.11h-6.38v-9.66h6.23v1.11h-4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.46,33.45v1.11h-6.19v-9.66h1.25v8.55h4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.45,31.68l-1.06,2.88h-1.33l3.66-9.66h1.7l3.68,9.66h-1.34l-1.04-2.88h-4.26ZM146.99,29.7c-.49-1.34-.94-2.59-1.4-3.93h-.03c-.46,1.34-.91,2.59-1.4,3.93l-.33.88h3.46l-.31-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.31,24.9c2.22,0,3.26.99,3.26,2.46,0,1.09-.56,1.87-1.6,2.25v.03c1.15.27,1.82,1.09,1.82,2.27,0,1.61-1.18,2.66-3.21,2.66h-3.4v-9.66h3.15ZM152.42,29.12h1.8c1.52,0,2.12-.61,2.12-1.59s-.61-1.57-2.06-1.57h-1.86v3.16ZM152.42,33.5h1.98c1.42,0,2.1-.58,2.1-1.67s-.67-1.67-2.28-1.67h-1.8v3.34Z"
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 49,
    y1: 1.02,
    x2: 49,
    y2: 39.02
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 26.5,
    y: -0.86,
    width: 17.26,
    height: 17.26,
    transform: "translate(20.05 40.44) rotate(-77.7)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.41,
    y: 27.32,
    width: 12.2,
    height: 12.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.87,
    y: 27.32,
    width: 12.2,
    height: 12.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 27.6,
    y: 15.14,
    width: 12.2,
    height: 12.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 13.13,
    y: 15.14,
    width: 12.2,
    height: 12.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 27.59,
    y: 27.32,
    width: 12.2,
    height: 12.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoDashboard);
export default __webpack_public_path__ + "static/media/Main-Logo_Dashboard.1d02c0d8972a203796e39a77b0f1a28a.svg";
export { ForwardRef as ReactComponent };